import { Component, input, output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface MaterialSummary {
    lineCount: number
    vendorCount: number
    distinctDescriptions: number
    distinctPartNumbers: number
    spend: number
    missingPartPercent: number
    missingUnitPercent: number
}

interface MaterialCategory {
    category: string
    lineCount: number
    vendorCount: number
    spend: number
}

@Component({
    selector: 'app-purchased-materials-overview',
    templateUrl: './purchased-materials-overview.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsOverviewComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)
    categoriesLoaded = output<string[]>()

    summary: MaterialSummary | null = null
    categoryGrid: Grid<MaterialCategory>

    constructor() {
        super()
        this.categoryGrid = new Grid<MaterialCategory>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, false),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    private clear() {
        this.summary = null
        this.categoryGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetOverview', filters))
                .subscribe({
                    next: result => {
                        const data = result[0]
                        this.summary = data.summary
                        this.categoryGrid.items = data.categories
                        const names = (data.categories as MaterialCategory[])
                            .map(row => row.category)
                            .filter(name => !!name && name !== '(none)')
                        this.categoriesLoaded.emit(names)
                    },
                }),
        )
    }
}
